import React from "react";
import Spinner from "../components/loaders/Spinner";
import loadable from "../utils/loadable";

// Dashboard
export const Dashboard = loadable(() => import("./Dashboard"), {
  fallback: <Spinner />
});

// Report
export const Report = loadable(() => import("./Report"), {
  fallback: <Spinner />
});

// Login
export const Login = loadable(() => import("./Login"), {
  fallback: <Spinner />
});

// ForgotPassword
export const ForgotPassword = loadable(() => import("./ForgotPassword"), {
  fallback: <Spinner />
});

// AffiliateList
export const AffiliateList = loadable(() => import("./Affiliate"), {
  fallback: <Spinner />
});

// Franchise
export const Franchise = loadable(() => import("./Franchise/Franchise"), {
  fallback: <Spinner />
});
// Payout
export const Payout = loadable(() => import("./Payout"), {
  fallback: <Spinner />
});

// NotFound
export const NotFound = loadable(() => import("./NotFound"), {
  fallback: <Spinner />
});
